class ValidationError extends Error {
  constructor(messages) {
    super('Sended data is invalid')
    this.name = 'ValidationError'
    this.messages = messages
  }
}

export default ValidationError
